// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-list .video-title[data-v-76b91168] {\n  padding-left: 4.5894vw;\n  height: 10.628vw;\n  font-size: 3.8647vw;\n  font-weight: 700;\n  text-align: left;\n  display: flex;\n  align-items: center;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
